export const odemeAyar = {
    akbankGetir: (istemci) => istemci.istek('/odeme-ayar/akbank'),
    akbankKaydet: (istemci, giris) => istemci.istek('/odeme-ayar/akbank', {
        method: 'PATCH',
        body: JSON.stringify(giris),
    }),
    akbankTest: (istemci) => istemci.istek('/odeme-ayar/akbank/test', { method: 'POST' }),
};
export const odeme = {
    intent: (istemci, giris) => istemci.istek('/odeme/intent', {
        method: 'POST',
        body: JSON.stringify(giris),
    }),
    durum: (istemci, token) => istemci.istek(`/odeme/durum/${token}`),
};
//# sourceMappingURL=odeme-ayar.js.map